import { MapContainer } from './MapContainer';

export const MapPage = () => {
  return (
    <section className="relative h-500 tableSmart:h-[calc(100vh-267px)] w-full">
      <div className="bg-cover bg-center bg-train bg-no-repeat absolute top-0 right-0 bottom-0 left-0 flex justify-center items-center">
        <MapContainer />
      </div>
    </section>
  );
};
